<template>
  <div class="logo">
    <router-link v-if="hidelogo" :to="{name:'Workplace'}">
      <img :src="logo"/>
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
    <div v-else>
      <img :src="logo"/>
      <h1 v-if="showTitle">{{ title }}</h1>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Logo',
  props: {
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  computed: {
    title(){
      return this.$store.state.brand.title
    },
    logo(){
      return this.$store.state.brand.logo
    },
    hidelogo(){
      return !this.$store.state.brand.extend.includes('HideLogo')
    }
  },
  created(){
  }
}
</script>
